import type { Optional } from '@festina-life/core'

import type {
  FPlusExpressionValue,
  TemplateFieldWithCardinality,
} from '../../types/templateModel'

export const expressionFromTemplateFieldWithCardinality = (
  field: TemplateFieldWithCardinality,
): Optional<FPlusExpressionValue> => field.value?.cardinality?.expression
